<template>
    <div class="instagram-widget" >
        <div class="white-wrapper-right">
        </div>
        <splide :options="options" :extensions="extensions" :slides="mediaList"
                @splide:active="startTimer" ref="splide" >
            <template v-for="(media, idx) in mediaList">
                <splide-slide>
                    <img :src="media['src']">
                    <div class="splide__video" style="display: block;">
                        <div>
                            <video :src="media['video']" autoplay loop muted playsinline></video>
                        </div>
                    </div>
                </splide-slide>
            </template>
        </splide>
        <div class="white-wrapper-left">
        </div>
        <div class="social" v-if="!hideSocial">
            <p class="social-description">Every day we publish video reviews on new hypercasual games.</p>
            <div class="icons">
                <a href="https://vt.tiktok.com/yqTjdN/" target="_blank">
                    <img src="/img/tik-tok.svg" class="tik-tok"></a>
                <a href="https://instagram.com/storeglide?igshid=kkso8smkzn13" target="_blank">
                    <img src="/img/instagram.svg" class="instagram"></a>
                <a href="https://t.me/storeglide" target="_blank">
                    <img src="/img/telegram.svg" class="telegram"></a>
            </div>
        </div>
    </div>

</template>

<script>

import {Splide, SplideSlide} from '@splidejs/vue-splide';
import Video from '@splidejs/splide-extension-video';

import '@splidejs/splide/dist/css/themes/splide-default.min.css';
import '@splidejs/splide-extension-video/dist/css/splide-extension-video.min.css';

export default {
    components: {
        Splide,
        SplideSlide,
    },
    props: [
        'hideSocial'
    ],
    data() {
        return {
            mediaList: [],
            timer: null,
            autoplay: true,
            options: {
                rewind: true,
                arrows: false,
                width: window.innerWidth <= 991 ? 340 : 297,
                height: 306,
                type: 'loop',
                padding: {
                    right: window.innerWidth <= 991 ? '50px' : '25px',
                    left:  window.innerWidth <= 991 ? '50px' : '25px',
                },
                lazyLoad: 'sequential',
                video: {
                    autoplay: true,
                    mute: true,
                    hideControls: true,
                    loop: true,
                    playerOptions: {
                        htmlVideo: {
                            playsinline: true,
                        },
                    }
                },
            },
            extensions: {
                Video,
            },
        };
    },
    methods: {
        loadPost: function () {
            axios.get("/api/instagram/feed").then(response => {
                this.mediaList = response.data;
            });
        },

        startTimer: (function () {
            var self = this;

            if (this.timer) {
                clearTimeout(this.timer);
            }
            this.timer = setTimeout(function () {
                self.$refs.splide.go(self.$refs.splide.index + 1);
            }, 5000);

        }),


    },
    mounted() {
        this.loadPost();
    },

};


</script>
<style>

.mobile-instagram-widget {
    display: none;
    margin: 0 auto;
}
.white-wrapper-left, .white-wrapper-right {
    height: 306px;
    background: linear-gradient(270deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 75%);
    width: 20px;
    position: absolute;
    z-index: 1;
}

.white-wrapper-right {
    left: 277px;
}

.white-wrapper-left {
    transform: matrix(-1, 0, 0, 1, 0, 0);
    top: 0;
    left: 0;
}

.splide .splide__pagination {
    bottom: -25px;

}

.splide .splide__pagination__page {
    background: #E7E7FF;
}

.splide .splide__pagination__page.is-active {
    background: #9240F5;
    -webkit-transform: initial;
    transform: initial;
}

.splide .splide__slide img {
    width: 100%;
}


.splide .splide__slide:not(.is-active) {
    margin-right: 8px;
}

.splide .splide__video {
    width: 246px;
    height: 307px;
    background: none;
}

.splide .splide__slide.is-active {
    margin-right: 8px;
}

.instagram-widget {
    position: relative;
}

.instagram-widget .social {
    margin-top: 30px;
    text-align: center;
    max-width: 275px;
}

.instagram-widget .social .social-description {
    font-family: Montserrat;
    font-weight: 500;
    font-size: 14px;
}

.filter .instagram-widget .social .social-description {
    max-width: 305px;
}

.instagram-widget .social .icons img {
    margin: 0;
}
.instagram-widget .social .icons img:hover{
    filter: invert(46%) sepia(36%) saturate(7424%) hue-rotate(258deg) brightness(96%) contrast(112%);
}
.instagram-widget .social .icons {
    margin-top: 10px;
}

.instagram-widget .social .icons a {
    margin-right: 15px;
}

@media only screen and (max-width: 991px) {

    .instagram-widget {
        max-width: 340px !important;
    }
    .white-wrapper-right {
        left: 320px;
    }

    .splide__slide {
        width: 245px!important;
    }

    .filter .instagram-widget {
        display: none;
    }

    .mobile-instagram-widget {
        display: block !important;
        margin-top: 3px;
        margin-bottom: 3px;
        /*border-bottom: 1px solid #D5D5D5;*/
        background: white;
        padding-top: 20px;
        height: 459px;
        /*border-radius: 10px;*/
    }

     .mobile-instagram-widget .instagram-widget {
        max-width: 297px;
        margin: 0 auto;
    }

    .mobile-instagram-widget .splide {
        margin: 0 auto;
    }

     .mobile-instagram-widget .social {
        display: block !important;
        float: initial;
        margin: 0 auto;
        margin-top: 27px;
    }
}
</style>

